import styled from 'styled-components';

import { Flex } from '@ui-library/flex';
import { H1 } from '@ui-library/typography';

export const PageContainer = styled(Flex)`
  height: 100vh;
  background: ${({ theme }) => theme.token.colorPrimaryBgHover};
`;

export const CopyContainer = styled(Flex)`
  margin-top: auto;
  margin-bottom: auto;
  background: ${({ theme }) => theme.token.colorPrimaryBgHover};
`;

export const Hero = styled(H1)`
  font-family: 'PolySans Wide';
  font-size: 4em;
`;
